import React, { useEffect, useState } from "react";
import { ArabicToPersian } from "utils/ConvertToPersianTextFromArabic";

const useGetDefaultSelect = (params) => {
  const [showItem, setShowItem] = useState(false);

  useEffect(() => {
    const item = params?.MonthList?.map((month) => ({
      ItemContent: ArabicToPersian(month?.Name),
      ItemValue: month?.Id,
    }));

    setShowItem(!!item);
  }, [JSON.stringify(params)]);

  return showItem;
};

export default useGetDefaultSelect;
